import React from 'react';
import QRCode from 'react-qr-code';
import { systemCode, xs_languageCode } from '../../..';
import { getConfiguration } from '../../../data/utils/configuration';
import { getCurrencyValue } from '../../../data/utils/getCurrencyValue';
import { getBarcode } from '../../../data/utils/getBarcode';
import { getBarcodeIdTicket } from '../../../data/utils/getBarcodeIdTicket';

function FlashbetTicketFooter(props) {
	
	const ticketData = props.ticketData;
	const conf = getConfiguration();

	let linkTemplate = conf.qrct;
	if(linkTemplate != null && linkTemplate.length > 0){
		linkTemplate= linkTemplate.replace(/{{TICKET}}/g, ticketData.idTicket);
		linkTemplate = linkTemplate.replace(/{{LANG}}/g, xs_languageCode);
		linkTemplate = linkTemplate.replace(/{{SYSTEM_CODE}}/g, systemCode);
	}
	let minWin = 0;
	if(ticketData.purchaseType === 'systembets'){
	    minWin = ticketData.tuples[0].vMin;
	}
	
	return <>
    
	{
		ticketData.purchaseType === 'systembets'?
		<>
		    <div className="container border-2px border-bottom-none margin-top">
	        	<span className="h5 bold">TOT. IMPORTO SCOMMESSO</span>
	        	<span className="h4 bold fright"> {getCurrencyValue(ticketData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
	        </div>
	        <div className="container border-2px border-bottom-none">
		        <span className="h5">Totale numero combinazioni</span>
		        <span className="h5 fright">{ticketData.totCombs}</span>
	        </div>
	         <div className="container border-2px border-bottom-none">
             <div className="text-align-center">POTENZIALE VINCITA MINIMA + BONUS</div>
             <div className="h1 bold text-align-center"> {getCurrencyValue(minWin, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
             </div>
             <div className="container border-2px">
             	<div className="text-align-center">POTENZIALE VINCITA MASSIMA + BONUS</div>
             	<div className="h1 bold text-align-center">{getCurrencyValue(ticketData.win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
             </div>
		</>
		:
		<>
			<div className="container border-2px border-bottom-none">
        		<span className="h4 bold">IMPORTO SCOMMESSO</span>
        		<span className="h4 bold fright">{getCurrencyValue(ticketData.amount, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
		    </div>
		    <div className="container border-2px border-bottom-none">
		        <span className="h5 bold">Bonus</span>
		        <span className="h5 bold fright">{getCurrencyValue(ticketData.bonus, conf.cs.m, conf.cs.nd, conf.cs.ct)}</span>
		    </div>
		    <div className="container border-2px">
		        <div className="h5 bold text-align-center">VINCITA POTENZIALE</div>
		        <div className="h1 bold text-align-center">{getCurrencyValue(ticketData.win, conf.cs.m, conf.cs.nd, conf.cs.ct)}</div>
		    </div>
		</>
	}
	

    <div className="container border-2px margin-top page-break-inside-avoid">
        <p className="h6 bold italic">
            La presente stampa &egrave; un promemoria, non &egrave; una ricevuta di gioco valida per la riscossione della vincita.
			Il gioco &egrave; vietato ai minori e pu&ograve; creare dipendenza patologica.
			Per le probabilit&agrave; di vincita vai su {conf.url}
		</p>
    </div>
    <div> <img style={{ height: "50px", width:"100%"}} src={getBarcode(getBarcodeIdTicket(ticketData.idTicket, false), 1, false)} /></div>
    <p className="h5 sans-serif text-align-center">{ticketData.idTicket}</p>
    {linkTemplate && linkTemplate.length > 0 &&(
    	 <div className="d-flex page-break-inside-avoid">
			<div className="qrcode-container" >
				<QRCode value={linkTemplate} size="90"  style={{"marginTop":'1%', "marginBottom":'1%'}} />
			</div>	
            <p className="container border-2px h5 bold">
                Utilizza il QR
                code della tua
                scommessa
                e segui l'esito
                ovunque tu sia
            </p>
        </div>
    )}

	
	</>
}

export default FlashbetTicketFooter;